import React, { useEffect, useState, JSX } from 'react';
import { ApiHotel, ApiIncludedService } from '@ibe/api';
import { Col, Row } from 'reactstrap';
import { IncludedServicesUtil, ServiceSearchDetailParams } from '@ibe/components';

interface Props {
  hotelModel: ApiHotel;
  searchParams?: Partial<ServiceSearchDetailParams>;
  packageIncludedServices?: Array<ApiIncludedService>;
}

const IncludedServices = (props: Props): JSX.Element => {
  const [, setIncludedServices] = useState<ApiIncludedService[]>();
  const [, setExternalIncludedServices] = useState<ApiIncludedService[]>();

  function getIncludedServices(
    hotelModel: ApiHotel,
    searchParams?: Partial<ServiceSearchDetailParams>
  ) {
    return IncludedServicesUtil.getIncludedServices(
      hotelModel.includedServices,
      searchParams?.startDate
    );
  }

  const getExternalIncludedServices = (
    searchParams?: Partial<ServiceSearchDetailParams>,
    packageIncludedServices?: Array<ApiIncludedService>
  ): ApiIncludedService[] | undefined => {
    return IncludedServicesUtil.getIncludedServices(
      packageIncludedServices,
      searchParams?.startDate
    );
  };

  useEffect(() => {
    setIncludedServices(getIncludedServices(props.hotelModel, props.searchParams));
    setExternalIncludedServices(
      getExternalIncludedServices(props.searchParams, props.packageIncludedServices)
    );
  }, [props.hotelModel, props.searchParams]);

  return (
    <>
      <Row className="align-items-start flex-column">
        <Col md="auto mt-3 mb-1 mb-md-3">
          <Row className="align-items-center"></Row>
        </Col>
      </Row>
    </>
  );
};

export default IncludedServices;
